import i18next from "../i18n";
import { TableHeader } from "../types/all";
import { cn } from "../utils/styling";

export const DetailsButton = ({
  active,
  className,
  onClick,
}: {
  active?: boolean;
  className?: string;
  onClick?: () => void;
}) => {
  const styleClass = active ? "cursor-pointer text-lds-link-primary" : "cursor-text text-lds-foreground-disabled";
  return (
    <span className={cn("font-ds-body-semibold-md", styleClass, className)} onClick={onClick}>
      {i18next.t("general.details")}
    </span>
  );
};

export const detailsCellHeader = <T,>(
  props: Omit<TableHeader, "dataKey" | "label" | "valueTransformation">,
  onClick: (row: T) => void,
  isActive: (row: T) => boolean = () => true
) => {
  return {
    dataKey: null,
    isInDefault: true,
    isReadOnly: true,
    label: i18next.t("general.details"),
    onCellClick: onClick,
    valueTransformation: (row: T) => <DetailsButton active={isActive(row)} />,
    ...props,
  };
};
